import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ListSubheader from 'LuxKit/List/ListSubheader'
import React, { useCallback, useContext, useEffect } from 'react'
import OfferAirportSelectOption from './OfferAirportSelectOption'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useAirportSearch from 'hooks/Flights/useAirportSearch'
import { fetchPopularAirports } from 'actions/FlightActions'
import OfferPageDispatchContext from 'contexts/OfferPage/offerPageDispatchContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import noop from 'lib/function/noop'
import styled from 'styled-components'
import ListItemLoadingSkeleton from 'LuxKit/List/ListItemLoadingSkeleton'

const Wrapper = styled.div`
  position: relative; /* to make the <LoadingIndicator> work  */
`

interface Props {
  searchPhrase?: string
  selectedAirport?: App.Airport
  popularAirports: App.PopularAirports
  onSelectAirport?: (airport: App.AirportLocation) => void
}

function OfferAirportOptionsList(props: Props) {
  const {
    searchPhrase = '',
    selectedAirport,
    popularAirports,
    onSelectAirport = noop,
  } = props

  const dispatch = useAppDispatch()
  const offerPageDispatch = useContext(OfferPageDispatchContext)

  useEffect(() => {
    dispatch(fetchPopularAirports())
  }, [dispatch])

  const [airports, loading] = useAirportSearch(searchPhrase)

  const handleItemClick = useCallback((airport: App.AirportLocation) => {
    offerPageDispatch({
      type: OfferPageActions.setAirport,
      airport: {
        code: airport.airportCode,
        name: airport.airportName,
        latitude: airport.lt!,
        longitude: airport.lg!,
      },
    })
    onSelectAirport(airport)
  }, [offerPageDispatch, onSelectAirport])

  return <Wrapper>
    <LoadingIndicator floating visible={loading} />
    {searchPhrase.length < 2 && <VerticalSpacer gap={8}>
      <ListSubheader colour="neutral-three">Airports near you</ListSubheader>
      <div>
        {popularAirports.origins.map(airport => <OfferAirportSelectOption
          key={airport.airportCode}
          airport={airport}
          onClick={handleItemClick}
          selected={airport.airportCode === selectedAirport?.code}
          data-testid={`airport-select-${airport.airportCode}`}
        />)}
      </div>
    </VerticalSpacer>}

    {loading && !airports.length && <ListItemLoadingSkeleton size="large" title="8ch" subtitle="3ch" startIcon />}

    {searchPhrase.length > 1 && airports.map(airport => <OfferAirportSelectOption
      key={airport.airportCode}
      airport={airport}
      onClick={handleItemClick}
      selected={airport.airportCode === selectedAirport?.code}
      data-testid={`airport-select-${airport.airportCode}`}
    />)}
  </Wrapper>
}

export default withOfferPageAndReduxState((state, appState) => ({
  popularAirports: appState.flights.popularAirports,
  selectedAirport: state.airport,
}), OfferAirportOptionsList)
